import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";

export default function OnlineCommunityDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [community, setCommunity] = useState(null);
  const [loading, setLoading] = useState(true);
  const { logUserActivity , loading: userLoading} = useActivityLogger();
  useEffect(() => {
    const fetchCommunity = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/komunitas/${id}`);
        setCommunity(res.data);
      } catch (err) {
        setCommunity(null);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchCommunity();
    if (!userLoading) {
      logUserActivity(
        "user",
        "view_community_details",
        "OnlineCommunityDetails",
        `User viewed community details for ID: ${id}`
      );
    }
  }, [id, userLoading]);

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/background-mahasiswa.png')" }}
      ></div>
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative flex flex-col min-h-screen px-4 py-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={() => {
              logUserActivity(
                "user",
                "go_back_from_community_details",
                "OnlineCommunityDetails",
                "User navigated back from community details page"
              );
              navigate("/online-community");
            }}
          >
            <img src="/icon-back-white.png" alt="Back" className="h-6 w-6" />
          </button>
          <div className="h-6 w-6" />
        </div>

        {loading ? (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-white text-center">
              Memuat data komunitas...
            </div>
          </div>
        ) : !community ? (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-white text-center">
              Komunitas tidak ditemukan.
            </div>
          </div>
        ) : (
          <>
            {/* Avatar & Nama */}
            <div className="flex flex-col items-center mt-4">
              <img
                src={
                  community.image_url
                    ? (process.env.REACT_APP_MEDIA_BASE || "") +
                      community.image_url
                    : "/avatar.png"
                }
                alt="Profile"
                className="h-20 w-20 rounded-full border-4 border-white object-cover"
              />
              <h2 className="text-white text-base font-semibold mt-4 mb-6 text-center">
                {community.nama_komunitas || (
                  <span className="italic text-gray-200">Tanpa Nama</span>
                )}
              </h2>
            </div>

            {/* Kontak & Sosial Media */}
            <div className="flex flex-col items-center w-full mt-2">
              {community.nomor_hp && (
                <a
                  href={`tel:${community.nomor_hp}`}
                  className="w-full flex items-center justify-center gap-2 bg-white/80 border rounded-full py-3 shadow mb-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/icon-phone.png" alt="Call" className="h-5 w-5" />
                  {community.nomor_hp}
                </a>
              )}
              {community.website && (
                <a
                  href={
                    community.website.startsWith("http")
                      ? community.website
                      : "https://" + community.website
                  }
                  className="w-full flex items-center justify-center gap-2 bg-white/80 border rounded-full py-3 shadow mb-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/icon-globe.png"
                    alt="Website"
                    className="h-5 w-5"
                  />
                  Website
                </a>
              )}
              {community.whatsapp && (
                <a
                  href={`https://wa.me/${community.whatsapp.replace(/[^0-9]/g, "")}`}
                  className="w-full flex items-center justify-center gap-2 bg-white/80 border rounded-full py-3 shadow mb-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/icon-whatsapp.png"
                    alt="WhatsApp"
                    className="h-5 w-5"
                  />
                  WhatsApp
                </a>
              )}
              {community.instagram && (
                <a
                  href={`https://instagram.com/${community.instagram.replace(/^@/, "")}`}
                  className="w-full flex items-center justify-center gap-2 bg-white/80 border rounded-full py-3 shadow mb-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/icon-instagram.png"
                    alt="Instagram"
                    className="h-5 w-5"
                  />
                  Instagram
                </a>
              )}
              {/* Tambahkan tombol sosial media lain jika ada */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
